import { Input, Modal } from "antd";
import clsx from "clsx";
import { INVESTIGATE_TAG_DISPLAY } from "lib/constants";
import { formatAlertTagDisplayToSDK } from "lib/utils";
import { useEffect, useState } from "react";
import { showToast } from "ui/components/common";
import { convertAlertToCase } from "../service";
export default function CaseTypeModal({
  activeAlert,
  visible,
  onClose,
  onAlertStatusChange,
}) {
  const [tag, setTag] = useState<INVESTIGATE_TAG_DISPLAY>();
  const [othersText, setOthersText] = useState("");

  const classificationKeys: INVESTIGATE_TAG_DISPLAY[] = Object.values(
    INVESTIGATE_TAG_DISPLAY,
  );

  const changeAlertStatus = async () => {
    if (!tag) {
      showToast(1, "Please select a tag");
      return;
    }
    const sdkTag = formatAlertTagDisplayToSDK(tag);
    const res = await convertAlertToCase(activeAlert.id, sdkTag, othersText);
    if (res.status !== 200) {
      showToast(1, "Failed to convert alert to case, please try again later");
      return;
    } else {
      showToast(0, "Alert converted to case successfully");
      onAlertStatusChange?.();
      onClose?.();
    }
  };

  useEffect(() => {
    if (!visible) {
      return;
    }
    setTag(undefined);
    setOthersText("");
  }, [visible]);
  return (
    <Modal footer={false} open={visible} onClose={onClose} width={520}>
      <div
        className={clsx(
          tag === INVESTIGATE_TAG_DISPLAY.Others
            ? "-top-[405px]"
            : "-top-[335px]",
        )}
      >
        <div className="grid grid-cols-3 mb-4">
          {classificationKeys?.map((key) => (
            <button
              key={key}
              className={clsx(
                "rounded-lg h-[46px] w-[160px] text-center",
                tag == key ? "bg-[#DCE7FD]" : "hover:bg-[#EEEEEE]",
              )}
              onClick={() => {
                key != INVESTIGATE_TAG_DISPLAY.Others && setOthersText("");
                setTag(key);
              }}
            >
              {key}
            </button>
          ))}
        </div>
        {tag === INVESTIGATE_TAG_DISPLAY.Others && (
          <Input
            className="h-[54px] rounded-2xl px-2"
            value={othersText}
            onChange={(e) => {
              setOthersText(e.target.value);
            }}
          />
        )}

        <div className="mt-4 flex justify-end gap-1">
          <button
            className="cursor-pointer px-4 py-2  bg-whitetext-sm font-semibold text-blue-500 transition-colors hover:text-blue-400 hover:border-blue-400"
            onClick={() => {
              onClose?.();
            }}
          >
            Cancel
          </button>
          <button
            className="bg-blue-500 px-8 py-2 rounded-2xl text-sm font-semibold text-white transition-colors hover:bg-blue-400 disabled:hover:bg-blue-500 disabled:cursor-not-allowed disabled:opacity-50"
            onClick={() => {
              changeAlertStatus();
            }}
          >
            Confirm
          </button>
        </div>
      </div>
    </Modal>
  );
}
